export default __webpack_public_path__ + "static/media/fileUp.aa6bf831.svg";